import i18n from '@/utils/i18n';
import KlarnaBadgeIcon from '@assets/icons/klarna-badge.svg';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { ListItem } from '@/components/list-item';
import { PaymentMethodType } from '@/enums';
import type { KlarnaVariant } from '@/hooks/payments/klarna-types';

interface Props {
  disabled?: boolean;
  onSelect: () => void;
  variant: KlarnaVariant;
}

const KLARNA_BADGE_HEIGHT = 20;
const KLARNA_BADGE_WIDTH = 48;

export const PayByKlarnaFooter: React.FC<Props> = ({
  disabled,
  onSelect,
  variant,
}) => {
  const [styles] = useStyles();

  return (
    <ListItem
      disabled={disabled}
      item={{
        title: i18n.t(
          variant === PaymentMethodType.KLARNA
            ? 'pay_later_with_klarna'
            : 'pay_over_time_with_klarna',
        ),
        value: '',
      }}
      listItemStyle={[styles.listItem, disabled ? styles.disabled : null]}
      onSelect={() => {
        if (!disabled) {
          onSelect();
        }
      }}
      renderLeftComponent={() => (
        <KlarnaBadgeIcon
          height={KLARNA_BADGE_HEIGHT}
          width={KLARNA_BADGE_WIDTH}
        />
      )}
    />
  );
};

const useStyles = createStyles((theme) => ({
  disabled: {
    opacity: 0.4,
  },
  listItem: {
    paddingHorizontal: theme.sk.spacing.spaceLarge,
  },
}));
